import { company } from "titum-custom/details";
import React from "react";
import Barcode from "react-barcode";

export default function BarcodeCard(props) {
  const { product } = props;

  return (
    <div
      style={{
        border: "12px solid white",
        width: "25%",
        height: "1in",
        // MargineBottom: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        // padding: "2px",
        
        
      }}
    >
      <div
        style={{
          zIndex: 1000,
        }}
      >
        <p
          style={{
            writingMode: "vertical-rl",
            textOrientation: "sideways",
            fontSize: 10,
            fontWeight: "bold",
            zIndex: 1000,
          }}
        >
          {product?.itemMaster ? (
              <>
                {product.itemMaster.discountAmount != 0 || product.itemMaster.discountPercentage != 0 ? "DIS " : "\u00A0"}
                
                {product.itemMaster.discountAmount != 0 && `${product.itemMaster.discountAmount} Rs`}
                {product.itemMaster.discountAmount != 0 && product.itemMaster.discountPercentage != 0 ? " / " : ""}
                {product.itemMaster.discountPercentage != 0 && `${product.itemMaster.discountPercentage}%`}
              </>
            ) : (
              "\u00A0"
            )}
        </p>
      </div>

      <div style={{ display: "flex", flexDirection:"column" ,alignItems:"center", justifyContent: "space-between" }}>
        <p
          style={{
            textTransform: "uppercase",
            textAlign: "center",
            fontSize: 9,
            overflow: "hidden",
            whiteSpace: "nowrap",
            fontWeight: "bold",
            
          }}
        >
         {product?.itemMaster?.description ? product?.itemMaster?.description : "\u00A0" } {product?.itemMaster?.invoiceDiscountPercentage ? '- DIS:' + product?.itemMaster?.invoiceDiscountPercentage + '%': "\u00A0" } 
        </p>
       
        <Barcode
          fontSize={12}
          width={0.9}
          height={36}
          marginTop={5}
          marginBottom={5}
          value={product.stockBarcode || product.itemMaster.barcode}
          format="CODE128"
        />
        
        <p
          style={{
            fontSize:8,
            fontWeight: "bold",
            textAlign: "center",
            zIndex: 1000,
          }}
        >
         MAX IMAGIN 8
        </p>
      </div>

      <p
        style={{
          textTransform: "uppercase",
          fontSize: 10,
          whiteSpace: "nowrap",
          writingMode: "vertical-rl",
          textOrientation: "sideways",
          fontWeight: "bold",
        }}
      >
        
        Rs. {product.retailPrice} {product.itemMaster.sku ? "(" + product.itemMaster.sku + ")" : "\u00A0"}
      </p>
    </div>
  );
}
